import { reducerTypes } from "./types";
import { IPageInfo } from "../../interfaces/common";
import { IModel } from "../../interfaces/product";

export const getModelsAction = (data: IModel[]) => ({
  type: reducerTypes.GET_ALL_MODELS,
  payload: data,
});

export const getMoreModelsAction = (data: IModel[]) => ({
  type: reducerTypes.GET_MORE_MODELS,
  payload: data,
});

export const getModelAction = (data: IModel) => ({
  type: reducerTypes.GET_MODEL,
  payload: data,
});

export const setSizePageAction = (page: IPageInfo) => ({
  type: reducerTypes.SET_PAGE_INFO,
  payload: page,
});
